// extracted by mini-css-extract-plugin
module.exports = {"main":"login-layout_main__3JaoQ","footer":"login-layout_footer__25jPS"};